import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { useContext } from "react";
import { forwardRef } from "react";
import moment from "moment";

import { PostService } from "../services/post-service";
import GeneralTable from "../components/layouts/general-table";
import TitleGrows from "../components/title-grows";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from '@mui/material/styles';
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

//Snackbar
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import AuthContext from "../context/auth-context";
import * as userpermission from "../utils/PermissionCheck.js";

import debounce from "lodash/debounce";
import Downloading from "../components/layouts/downloading";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";

const DarkTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#212529",
    color: "white",
    boxShadow: theme.shadows[3],
    fontSize: 11,
  },
}));

const styleMd = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  padding: "16px 0",
  textAlign: "center",
};

export default function Articles(tagId = "") {
  const debounceTriggeredAfter = 250; ///ms
  const authCtx = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState(false);
  const [downloadLinearProgress, setDownloadLinearProgress] = useState(false);
  const [cols, setCols] = useState([]);
  const [pages, setPages] = useState([]);
  const [tParams, setTParams] = useState({ page: 1, page_size: 10 });
  const [itemsCount, setItemsCount] = useState(0);
  //eslint-disable-next-line
  const [errors, setErrors] = useState([]);
  const [authorList, setAuthorList] = useState([]);

  const [stateSB, setStateSB] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
    message: "",
    severity: "success",
    ahduration: 3000,
    instructions: "",
  });

  const {
    open,
    vertical,
    horizontal,
    message,
    severity,
    ahduration,
    instructions,
  } = stateSB;
  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleChanges = (tableParams) => {
    setCols(tableParams?.colsOut);
    delete tableParams.colsOut;
    setTParams(tableParams);
    getData(tableParams);
  };

  const [openMd, setOpenMd] = useState(false);
  const handleOpenMd = () => setOpenMd(true);
  const handleCloseMd = () => setOpenMd(false);

  const uniqueData = (udata) => {
    return Array.from(new Set(udata));
  };

  //debounce
  const getData = useCallback(
    async (params = {}) => {
      setIsLoading(true);

      try {
        let resObject = undefined;
        if (
          userpermission.PermissionCheck("can_edit_post_prices", [
            ...authCtx.permissionList,
          ])
        ) {
          let _p = { ...params, serializer: "with_price" };
          resObject = await PostService.getBackOfficeList(_p);
        } else {
          resObject = await PostService.getBackOfficeList(params);
        }
        if (!resObject || (resObject?.status && resObject?.status !== 200)) {
          console.log(`Error getList: `, resObject);
          setPages([]);
          setItemsCount(0);
          setIsLoading(false);
          if (resObject) setErrors(resObject.data);
          return {
            revalidate: 5,
            notFound: true,
          };
        }
        setItemsCount(resObject.count);
        setPages(resObject.results);
        setIsLoading(false);
        setErrors([]);
      } catch (e) {
        console.log(e);
        return {
          revalidate: 5,
          notFound: true,
        };
      }
    },
    [authCtx.permissionList]
  );

  const getDataAuthorList = useCallback(async (_pageSizeAuthor) => {
    const authorList = await PostService.getAuthorList({
      page_size: _pageSizeAuthor,
    });

    if (authorList.count === 0) {
      console.error(`No Author list for params`);
    } else {
      var authorListFN = authorList.results.map(function (author) {
        return author.full_name;
      });
      setAuthorList(uniqueData(authorListFN));
    }
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getDataAuthorList(100);
      getData();
    }, debounceTriggeredAfter);
    return () => {
      clearTimeout(delayDebounceFn);
      setIsLoading(false);
      setPages([]);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    createColumns();
    // eslint-disable-next-line
  }, [authorList]);

  const buttonsMenu = [
    //(userpermission.PermissionCheck('can_edit_post_prices', [...authCtx.permissionList]) ? [
    <Button
      key="download_reports"
      disabled={downloadLinearProgress}
      tabIndex={-1}
      variant="outlined"
      size="small"
      //color="success"
      onClick={handleOpenMd}
      title="Download dei reports"
      style={{ minWidth: "80px", padding: "6px" }}
    >
      Export{" "}
      <FontAwesomeIcon
        icon={["fas", "fa-download"]}
        size={"2x"}
        color={"#0a58ca"}
      />
    </Button>,
    <Button
      key="reset_all"
      tabIndex={-1}
      variant="outlined"
      size="small"
      //color="success"
      onClick={() => {
        window.location.reload(false);
      }}
      title="Ricarica la tabella"
      style={{ minWidth: "80px", padding: "6px" }}
    >
      RESET ALL
    </Button>,
  ];
  //] : [];

  const totalsFields = [
    ["total_first_day", "Visualizzazioni nel giorno della pubblicazione"],
    [
      "total_first_3_days",
      "Visualizzazioni dopo 3 gg dalla data di pubblicazione",
    ],
    [
      "total_first_7_days",
      "Visualizzazioni dopo 7 gg dalla data di pubblicazione",
    ],
    [
      "total_first_28_days",
      "Visualizzazioni dopo 28 gg dalla data di pubblicazione",
    ],
    [
      "total_lifetime",
      "Visualizzazioni dalla data di pubblicazione alla data di aggiornamento",
    ],
  ];

  let totals_fld = totalsFields.map((field) => {
    return {
      label: (
        field[0].replace(/total_/g, "").replace(/_/g, " ") + " PAGEVIEWS"
      ).toUpperCase(),
      labelTooltip: field[1],
      key: "totals__" + field[0],
      isSortable: true,
      isVisible: false,
      sxStyledFilterCell: {},
      sxStyledTableCell: { minWidth: "164px" },
      sxTableCell: {},
      render: (col, row) => {
        return (
          <div style={{ fontWeight: "bold" }}>
            {row?.totals && row?.totals[field[0]]}
          </div>
        );
      },
    };
  });

  function createColumns() {
    let tempCols = [
      {
        label: "WP ID",
        labelTooltip: "ID database WordPress",
        key: "databaseId",
        isSortable: true,
        isVisible: true,
        isFilterable: { filters: ["databaseId"] },
        arrOptions: [],
        sxStyledFilterCell: {},
        sxStyledTableCell: { minWidth: "100px" },
        sxTableCell: {},
      },
      {
        label: "KIND",
        labelTooltip: "",
        key: "kind",
        isSortable: false,
        isVisible: true,
        sxStyledFilterCell: {},
        sxStyledTableCell: {},
        sxTableCell: {},
      },
      {
        label: "ORIGIN DOMAIN",
        labelTooltip: "",
        key: "origin_domain",
        isSortable: true,
        isVisible: true,
        isFilterable: { filters: ["origin_domain"] },
        arrOptions: [
          "www",
          "impact",
          "cybersecurity",
          "ischool",
          "openinnovation",
          "smartworking",
          "smartmoney",
          "sportup",
          "thefoodmakers",
          "thenexttech",
          "valoreresponsabile",
          "life",
        ],
        sxStyledFilterCell: {},
        sxStyledTableCell: { minWidth: "172px" },
        sxTableCell: {},
      },
      {
        label: "HASHTAG",
        labelTooltip: "",
        key: "tags",
        isSortable: false,
        isVisible: true,
        isFilterable: { filters: ["tags_slug__icontains"] },
        arrOptions: [],
        sxStyledFilterCell: {},
        sxStyledTableCell: { minWidth: "120px" },
        sxTableCell: {},
        render: (col, row) => {
          return (
            <>
              <ul
                className="list-group list-group-flush"
                style={{ listStyleType: "none" }}
              >
                {row?.tags?.length > 0 && row?.tags?.length < 3 ? (
                  row?.tags.map((e, index) => (
                    <li
                      className="list-group-item"
                      style={{ padding: "1px" }}
                      key={index}
                    >
                      {/* {e?.id === Number(tagId) && row?.tags?.length > 1 ? (
                            <div
                              style={{
                                fontWeight: 700,
                                fontSize: "16px",
                                color: "#198754",
                              }}
                            >
                              {e?.slug}
                            </div>
                          ) : ( */}
                      {e?.slug}
                      {/* )} */}
                    </li>
                  ))
                ) : row?.tags?.length ? (
                  <DarkTooltip
                    title={row?.tags.map((e, index) => (
                      <ListItem
                        key={index}
                        disablePadding={true}
                        // sx={{
                        //   backgroundColor: "white",
                        // }}
                      >
                        <ListItemText primary={e?.slug} />
                      </ListItem>
                    ))}
                    placement="top-start"
                  >
                    <div>{row?.tags?.length}</div>
                  </DarkTooltip>
                ) : (
                  <div>{row?.tags?.length}</div>
                )}
              </ul>
            </>
          );
        },
      },
      {
        label: "TITLE",
        labelTooltip: "",
        key: "title",
        isSortable: true,
        isVisible: true,
        isFilterable: { filters: ["title__icontains"] },
        arrOptions: [],
        sxStyledFilterCell: {},
        sxStyledTableCell: { minWidth: "160px" },
        sxTableCell: {},
      },
      {
        label: "URL",
        labelTooltip: "",
        key: "uri",
        isSortable: true,
        isVisible: true,
        isFilterable: { filters: ["uri__icontains"] },
        arrOptions: [],
        sxStyledFilterCell: {},
        sxStyledTableCell: { minWidth: "180px" },
        sxTableCell: {},
      },
      {
        label: "PUBLISHED",
        labelTooltip: "Data di pubblicazione",
        key: "published",
        isSortable: true,
        isVisible: true,
        //published__gte => Date Start, published__lte => Date End
        isFilterable: {
          type: "date_range",
          filters: ["published__gte", "published__lte"],
        },
        sxStyledFilterCell: { minWidth: "318px" },
        sxStyledTableCell: {},
        sxTableCell: {},
        render: (col, row) => {
          return moment(row.published).locale("it").format(`D MMMM YYYY HH:MM`);
        },
      },
      {
        label: "AUTHOR",
        labelTooltip: "",
        key: "author",
        isSortable: true,
        isVisible: true,
        isFilterable: { filters: ["author__full_name__icontains"] },
        arrOptions: authorList,
        sxStyledFilterCell: { minWidth: "150px" },
        sxStyledTableCell: {},
        sxTableCell: {},
        render: (col, row) => {
          return <>{row?.author?.full_name}</>;
        },
      },
      {
        label: "UPDATED PAGEVIEWS",
        labelTooltip: "Data ultimo aggiornamento delle pageviews (GA)",
        key: "totals__updated",
        isSortable: true,
        isVisible: false,
        sxStyledFilterCell: {},
        sxStyledTableCell: {},
        sxTableCell: {},
        render: (col, row) => {
          return (
            <>
              {moment(row?.totals?.updated)
                .locale("it")
                .format(`D/MM/YYYY HH:MM`)}
            </>
          );
        },
      },
      ...totals_fld,
      {
        label: "",
        labelTooltip: "",
        key: "action",
        isSortable: false,
        isVisible: true,
        sxStyledFilterCell: {},
        sxStyledTableCell: {},
        sxTableCell: {},
        render: (col, row) => {
          return (
            <a
              type="button"
              tabIndex={-1}
              href={
                row.origin_domain !== "www"
                  ? `https://${row.origin_domain}-admin.startupitalia.eu/wp-admin/post.php?post=${row.databaseId}&action=edit&classic-editor`
                  : `https://admin.startupitalia.eu/wp-admin/post.php?post=${row.databaseId}&action=edit&classic-editor`
              }
              title="Visualizza l'articolo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconButton
                tabIndex={-1}
                edge="end"
                aria-label="external-link"
                title="Vai all'articolo"
                id="button-external"
                style={{ minWidth: "40px" }}
              >
                <FontAwesomeIcon
                  icon={["fas", "external-link-alt"]}
                  size={"1x"}
                  color={"#6c757d"}
                />
              </IconButton>
            </a>
          );
        },
      },
    ];
    if (
      userpermission.PermissionCheck("can_edit_post_prices", [
        ...authCtx.permissionList,
      ])
    ) {
      let price_fld = {
        label: "PRICE",
        labelTooltip: "Prezzo del singolo post",
        key: "price",
        isSortable: false,
        isVisible: false,
        //isFilterable: { filters: ['price'] },
        arrOptions: ["5.00", "10.00", "15.00", "20.00"],
        sxStyledFilterCell: {},
        sxStyledTableCell: {},
        sxTableCell: { backgroundColor: "#00000004" }, //test sx backgroundColor
        render: (col, row) => {
          return (
            <>
              <Paper
                sx={{
                  p: "0px 1px",
                  display: "flex",
                  alignItems: "center",
                  minWidth: 130,
                  maxWidth: 160,
                }}
              >
                <InputBase
                  tabIndex="0"
                  id={`${row.id}`}
                  type="number"
                  defaultValue={row?.price?.price}
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="€"
                  style={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "post price" }}
                  onChange={debounce((event) => {
                    //event.target.value.replace(/[^0-9]/g, '')
                    event.target.style.border = "thick solid #ffc107";
                    event.target.style.borderRadius = "5px";
                  }, debounceTriggeredAfter)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      // Prevent's default 'Enter' behavior.
                      event.preventDefault();
                      savePrice(row.id);
                    }
                  }}
                />
                <Divider
                  sx={{ height: "28px !important", m: 0.5 }}
                  orientation="vertical"
                />
                <IconButton
                  tabIndex={-1}
                  onClick={() => {
                    savePrice(row.id);
                  }}
                  edge="end"
                  aria-label="save_price"
                  title="Salva il prezzo"
                  style={{ margin: "2px" }}
                >
                  <FontAwesomeIcon
                    icon={["fas", "save"]}
                    size={"1x"}
                    color={"#0d6efd"}
                  />
                </IconButton>
              </Paper>
            </>
          );
        },
      };

      tempCols.splice(7, 0, price_fld);

      //tempCols.push(field_price, ...totals)
      // const indexOfObjectPrice = tempCols.findIndex(object => {
      //   return object.key === 'price';
      // });
      // tempCols.splice(indexOfObjectPrice, 1);
    }
    setCols(tempCols);
  }

  const exportAsyncData = useCallback(
    async (file_format = "csv") => {
      setOpenMd(false);
      let parameters = {};
      parameters.filters = tParams;
      parameters.file_format = file_format;

      setDownloadLinearProgress(true);

      try {
        let resObject = await PostService.asyncDownloadBackOfficeFile(
          parameters
        );
        if (!resObject || resObject?.status !== 202) {
          setDownloadLinearProgress(false);
          console.log(`Not accepted for processing: `, resObject?.status);
          //setErrors(res.error_msg);
          return {
            revalidate: 5,
            notFound: true,
          };
        } else {
          console.log(resObject.data.task_id);
          const task_id = resObject.data.task_id;
          if (task_id && task_id !== "") {
            const interval = setInterval(async () => {
              let res = await PostService.checkCeleryTaskId({
                task_id: task_id,
              });
              if (!res || res?.data.state !== "SUCCESS") {
                setDownloadLinearProgress(false);
                clearInterval(interval);
                console.log(
                  `STOP! Not accepted for processing: `,
                  res?.data.state + " task_id: " + task_id
                );
                return {
                  revalidate: 5,
                  notFound: true,
                };
              } else {
                setDownloadLinearProgress(false);
                clearInterval(interval);
                console.log(res.data.result);

                const link = document.createElement("a");
                link.href = "http://localhost:8668" + res.data.result.file_url;
                link.setAttribute("download", `export_all_articles.csv`);
                document.body.appendChild(link);
                link.click();
              }
            }, 1000);
          }
        }
      } catch (e) {
        setDownloadLinearProgress(false);
        console.log(e);
        return {
          revalidate: 5,
          notFound: true,
        };
      }
    },
    [tParams]
  );

  const savePrice = useCallback(async (id) => {
    let elementPrice = document.getElementById(id);
    let params = { price: 0.0 };
    try {
      if (elementPrice && elementPrice.value) {
        params = { price: elementPrice.value };
      } else {
        elementPrice.value = 0;
      }
      //console.log('********', elementPrice.value);

      let resObject = await PostService.updatePrice(id, params);
      let res = {
        price: resObject.data,
        error_code: resObject.status,
        error_msg: resObject.data,
      };
      if (!res || res.error_code !== 200) {
        console.log(`Error setPrice: `, res.error_msg);
        elementPrice.style.border = "thick solid #dc3545";
        //setErrors(res.error_msg);
        setStateSB({
          open: true,
          vertical: "top",
          horizontal: "center",
          message: "Errore, non è stato possibile salvare!",
          severity: "error",
          ahduration: null,
          instructions: null,
        });
        return {
          revalidate: 5,
          notFound: true,
        };
      }
      //console.log(`Result of PUT:`, res.price);
      elementPrice.style.border = "white";
      setStateSB({
        open: true,
        vertical: "top",
        horizontal: "center",
        message: "Salvato correttamente!",
        severity: "success",
        ahduration: 2000,
        instructions: null,
      });
    } catch (e) {
      console.log(e);
      elementPrice.style.border = "thick solid #dc3545";
      setStateSB({
        open: true,
        vertical: "top",
        horizontal: "center",
        message: "Errore, non è stato possibile salvare!",
        severity: "error",
        ahduration: null,
        instructions: null,
      });
      return {
        revalidate: 5,
        notFound: true,
      };
    }
  }, []);

  // const handleChange = (event) => {
  //   event.target.value.replace(/[^0-9]/g, '')
  //   event.target.style.border = 'thick solid #ffc107'
  //   event.target.style.borderRadius = '5px'
  // };

  const handleCloseSB = () => {
    setStateSB({ ...stateSB, open: false });
  };

  return (
    <>
      <div className="d-flex flex-column h-100">
        <div className="flex-grow-0">
          <TitleGrows txtTitle="Articles" />
        </div>
        <div className="flex-grow-1">
          {downloadLinearProgress && <Downloading />}
          <GeneralTable
            buttonsMenu={buttonsMenu}
            cols={cols}
            data={pages}
            itemsCount={itemsCount}
            isLoading={isLoading}
            /* initialOptions={
            { initialOrdering: { key: 'databaseId', asc: false } }
          } */
            handleChanges={handleChanges}
            // generalOptions={{ rowsPerPageOptions: [1, 2, 10, 25, 50] }}
          />
        </div>
      </div>

      <Snackbar
        open={open}
        autoHideDuration={ahduration}
        onClose={handleCloseSB}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleCloseSB}
          severity={severity}
          sx={{ width: "100%" }}
        >
          <div style={{ textAlign: "center" }}>{message}</div>
          {instructions ? (
            <div style={{ margin: "10px 0 0 0" }}>{instructions}</div>
          ) : (
            ""
          )}
        </Alert>
      </Snackbar>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openMd}
        onClose={handleCloseMd}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openMd}>
          <Box sx={styleMd}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              Download reports
            </Typography>
            <Button
              key="export_all_data_xlsx"
              //disabled={downloadLinearProgress}
              tabIndex={-1}
              variant="outlined"
              size="large"
              color="success"
              onClick={() => {
                exportAsyncData("xlsx");
              }}
              title="Esporta i dati in excel"
              style={{ minWidth: "136px", margin: "16px" }}
            >
              <span style={{ padding: "4px" }}>EXCEL</span>
              <span style={{ padding: "4px" }}>
                <FontAwesomeIcon
                  icon={["fas", "file-excel"]}
                  size={"2x"}
                  color={"#198754"}
                />
              </span>
            </Button>
            <Button
              key="export_all_data_csv"
              //disabled={downloadLinearProgress}
              tabIndex={-1}
              variant="outlined"
              size="large"
              //color="success"
              onClick={() => {
                exportAsyncData("csv");
              }}
              title="Esporta i dati in csv"
              style={{ minWidth: "136px", margin: "16px" }}
            >
              <span style={{ padding: "4px" }}>CSV</span>
              <span style={{ padding: "4px" }}>
                <FontAwesomeIcon
                  icon={["fas", "file-csv"]}
                  size={"2x"}
                  color={"#0d6efd"}
                />
              </span>
            </Button>
            <hr />
            <Button tabIndex={-1} variant="contained" onClick={handleCloseMd}>
              Chiudi
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
